import { Button, Form, Modal, message } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";

import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import { saveDeactiveEmployeeDetails } from "../../redux/DeactiveEmployee/action";
import useSession from "../CustomLogout/useSession";
import ModalHeaderText from "../../common/ModalHeaders/ModalHeaderText";
import UiTextArea from "../UiTextArea/TextArea";
import { useDispatch } from "react-redux";
import { setPartnerUserPrimaryDetails } from "../../redux/AddUserDetails/action";
const MakePrimaryUser = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const handleSessionExpired = useSession();
  const [form] = Form.useForm();
  const [saveLoading, setSaveLoading] = useState(false);
  const dispatch = useDispatch();

  const handleMakePrimary = () => {
    setSaveLoading(true);

    dispatch(
      setPartnerUserPrimaryDetails({
        userId: props.row?.original?.userId,
        access_token: props.access_token,
      })
    )
      .then((res) => {
        setSaveLoading(false);
        if (res && res.status === 200) {
          setTimeout(() => {
            message.success(
              `${props.row?.original?.userFullName} is now the Primary User`
            );
          }, 2000);
          handleCancel();
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        setSaveLoading(false);
      });
  };

  const handleCancel = () => {
    setDrawerOpen(false);
    form.resetFields();
  };

  return (
    <div className="deactivate-partner-sec">
      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="activatePartner"
          layout="vertical"
          form={form}
          onFinish={handleMakePrimary}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Make as Primary User" />
              </Col>
            </Col>
          </Row>
          <Row className="">
            <Col md={12}>
              <p>
                By clicking Confirm, the user will be set as the primary user.
                As a primary user, they will have privileges to User Management
                and will be able to view all partner leads.
              </p>
            </Col>
          </Row>
          <Row className="">
            <Col md={12} className="d-flex justify-content-end">
              {saveLoading && (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              )}
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveDeactiveEmployeeDetails: (data) =>
      dispatch(saveDeactiveEmployeeDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MakePrimaryUser);
